export class mdlAddSequnceNoReq{
    public RegNo: string;
    public PolicyNo: string;
    public InsuredName: string;
    public CustomId: string; 
    public SequenceNo: string; 
    public ChassisNo:string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlAddSequnceNoReq.ts